<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <div class="d-flex">
                  <div class="flex-grow-1 align-self-center">
                    <div class="text-muted">
                      <p class="mb-2">
                        Καλώς ήρθες στο clockin
                        {{ objectUser.first_name }}
                        {{ objectUser.last_name }}
                      </p>
                      <h5 class="mb-1">
                        {{ objectUser.username }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- end row -->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">ΥΠΑΛΛΗΛΟΙ</p>
                  <h4 class="mb-0">{{ homeBannerData.people }}</h4>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle">
                  <span class="avatar-title"><i class="fas fa-user-tie"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <p class="text-muted fw-medium mb-2">ΤΜΗΜΑΤΑ</p>
                  <h4 class="mb-0">{{ homeBannerData.deps_count }}</h4>
                </div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="fas fa-landmark"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7" v-if="userCanUseProgramForAttendance">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Ώρα για προσέλευση ή αποχώρηση; Καταγράψτε την παρουσία σας εδώ!

            </h4>
            <button class="btn btn-primary btn-lg w-xs rounded-pill" @click.prevent="onEntrance"
              :disabled="isEntranceButtonDisabled" type="button">
              <!-- Start of button content -->
              <div class="btn-content">
                <span class="fw-medium mx-2 mx-2">ΠΡΟΣΕΛΕΥΣΗ</span>
                <i class="mdi mdi-login"></i>
              </div>
            </button><button class="btn btn-danger btn-lg w-xs rounded-pill mx-2" @click.prevent="onExit"
              :disabled="isExitButtonDisabled" type="button">
              <div class="btn-content">
                <span class="fw-medium mx-2">ΑΠΟΧΩΡΗΣΗ</span>
                <i class="mdi mdi-exit-run"></i>
              </div>
            </button>
            <!-- end of button content --->
          </div>
        </div>
      </div>
      <div v-if="has_holiday_module" class="col-md-7">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Χρειάζεστε άδεια; Υποβάλετε την αίτησή σας για έγκριση εδώ!
            </h4>
            <router-link to="request-holiday" class="btn btn-primary btn-lg w-xs rounded-pill mx-2">
              Υποβολή Αίτησης
            </router-link>

          </div>

        </div>

      </div>

      <div>
        <img :src="require('../../../assets/images/banner-primary.png')"
          style="margin-left:auto;margin-right:auto;display:block;opacity:0.4" />
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
import session from "../../../api/session";
export default {
  page: {
    title: "ΑΡΧΙΚΗ",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },

  mounted() {
    // this.resetCountersIfNewDay();
    // this.resetCounterIfNewPerson();
    this.fetchHits();
  },
  data() {
    return {
      title: "Αρχικη",
      items: [
        {
          text: "Αρχική",
          href: "/",
        },
      ],
      maxPressLimit: 1,
      attendanceStatus: "",
      last_hit: {},
      // lastResetDate: localStorage.getItem("lastResetDate") || null,
      // attendanceStatus: localStorage.getItem("attendanceStatus") || "none",
      counters: JSON.parse(localStorage.getItem("attendanceCounters")) || {
        entrance: 0,
        exit: 0,
      },
    };
  },

  computed: {
    ...mapGetters("auth", [
      "userDetails",
      "objectUser",
      "is_superuser",
      "has_holiday_module",
    ]),

    ...mapState("people", ["homeBannerData"]),
    userCanUseProgramForAttendance() {
      if (this.is_superuser) {
        return true;
      }
      const personDevice = this.userDetails.person_device_identity;
      if (personDevice) {
        return personDevice.can_use_program_for_attendance;
      }
      return false;
    },

    isEntranceButtonDisabled() {
      return this.last_hit.attendance_option == 0;
    },
    isExitButtonDisabled() {
      return this.last_hit.attendance_option == 1;
    },
  },
  methods: {
    fetchHits() {
      session.get("api/process-attendances/").then((resp) => {
        this.last_hit = resp.data;
      });
    },
    // util methods
    showSaveSuccessMessage() {
      Swal.fire(
        "Αποθηκεύτηκαν!",
        "Οι αλλαγές αποθηκεύτηκαν με επιτυχία.",
        "success"
      );
    },

    showErrorMessage(errorMsg) {
      Swal.fire("Oυπς!", errorMsg, "error");
    },

    showToastrSuccessMessage(message) {
      this.$toastr.Add({
        name: "UniqueToastName",
        title: "Ενημέρωση",
        msg: message,
        style: { backgroundColor: "#4fd69c", width: "550px" },
        progressbar: false,
        timeout: 2000,
      });
    },

    async handleSaveConfirmation() {
      const result = await Swal.fire({
        title: "Έχετε προβεί σε πολλαπλές εισόδους",
        text: "Θέλετε να συνεχίσετε; Οι αλλαγές θα αποθηκευτούν.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι, αποθηκεύστε τις αλλαγές",
        cancelButtonText: "Άκυρο",
      });

      return result.isConfirmed;
    },

    onEntrance() {
      this.attendanceStatus = "entrance";
      this.handlePress("entrance");
    },

    onExit() {
      this.attendanceStatus = "exit";
      this.handlePress("exit");
    },

    handleSaveProcessAttendance() {
      const attendanceOption = this.attendanceStatus === "entrance" ? 0 : 1;
      session
        .post("api/process-attendances/create/", {
          attendance_option: attendanceOption,
        })
        .then(() => {
          this.fetchHits();
        })
        .catch((e) => {
          console.log(e);
          this.showErrorMessage(JSON.stringify(e.response.data));
        });
    },

    handleSaveAttendance() {
      const dataObject = {
        attendanceStatus: this.attendanceStatus,
        ...this.objectUser,
      };
      session
        .post("api/home/attendance-create/", dataObject)
        .then(() => {
          this.handleSaveProcessAttendance();
          this.showSaveSuccessMessage();
        })
        .catch((e) => {
          console.log(e);
          this.showErrorMessage(JSON.stringify(e.response.data));
        });
    },

    async handlePress(status) {
      if (this.objectUser.is_staff || this.objectUser.is_superuser) {
        this.showErrorMessage("Δεν γίνεται να καταγραφεί η παρουσία σε admin");
        return;
      }

      if (this.counters[status] >= this.maxPressLimit) {
        const isConfirmed = await this.handleSaveConfirmation();

        if (!isConfirmed) {
          return;
        } else {
          this.handleSaveAttendance();
          this.attendanceStatus = status;
        }
      } else {
        this.handleSaveAttendance();
        this.attendanceStatus = status;
      }

      // this.showToastrSuccessMessage("Τα στοιχεία ανανεώθηκαν επιτυχώς!");
    },

    resetCounterIfNewPerson() {
      const currentUser = localStorage.getItem("currentUser");
      if (currentUser != null) {
        if (parseInt(currentUser) != this.objectUser.id) {
          this.counters = { entrance: 0, exit: 0 };
          localStorage.setItem(
            "attendanceCounters",
            JSON.stringify(this.counters)
          );
          localStorage.removeItem("attendanceStatus");
          localStorage.setItem("currentUser", this.objectUser.id);
        }
      } else {
        this.counters = { entrance: 0, exit: 0 };
        localStorage.setItem(
          "attendanceCounters",
          JSON.stringify(this.counters)
        );
        localStorage.setItem("currentUser", this.objectUser.id);
      }
    },

    resetCountersIfNewDay() {
      const currentDateObj = moment();
      const lastResetDate = localStorage.getItem("lastResetDate");

      if (lastResetDate != null) {
        const lastResetDateObj = moment(lastResetDate, "DD/MM/YYYY");

        if (!lastResetDateObj.isSame(currentDateObj, "day")) {
          this.counters = { entrance: 0, exit: 0 };
          localStorage.setItem(
            "attendanceCounters",
            JSON.stringify(this.counters)
          );
          localStorage.removeItem("attendanceStatus");
          localStorage.setItem(
            "lastResetDate",
            currentDateObj.format("DD/MM/YYYY")
          );
        }
      } else {
        localStorage.setItem(
          "lastResetDate",
          currentDateObj.format("DD/MM/YYYY")
        );
      }
    },

    updateLocalStorage() {
      localStorage.setItem("attendanceCounters", JSON.stringify(this.counters));
    },
  },
};
</script>
